export { default } from './RenderInBody';
